export default {
  button: "Find",
  buttonHidden: "address from postcode",
  spinner: "Searching",
  spinnerHidden: "for address"
};
